import { render, staticRenderFns } from "./FloatingLabel.vue?vue&type=template&id=4547ced3&scoped=true"
import script from "./FloatingLabel.vue?vue&type=script&lang=js"
export * from "./FloatingLabel.vue?vue&type=script&lang=js"
import style0 from "./FloatingLabel.vue?vue&type=style&index=0&id=4547ced3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4547ced3",
  null
  
)

export default component.exports